import { useQueries } from '@tanstack/react-query';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { listMcpConnectorTools } from '@/services/mcp-gateway';
import type { McpConnector } from '@/services/mcp-gateway';

/**
 * For each read-only connection, the tool ids the gateway still lets agents use. Only read-only
 * connections are fetched (one request each); everything else is allowed by definition.
 */
export function useMcpConnectorAllowedTools(connectors: McpConnector[]): Map<string, Set<string>> {
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);
  const readOnly = connectors.filter((c) => c.read_only);

  const results = useQueries({
    queries: readOnly.map((c) => ({
      queryKey: ['mcp-connector-tools', orgId, c.id],
      queryFn: () => listMcpConnectorTools(c.id, orgId),
      enabled: !!orgId,
      staleTime: 60_000,
      retry: false,
    })),
  });

  const allowed = new Map<string, Set<string>>();
  readOnly.forEach((c, i) => {
    const data = results[i]?.data;
    if (data) allowed.set(c.id, new Set(data.map((t) => t.id)));
  });
  return allowed;
}
